export default __webpack_public_path__ + "static/media/person_2.3f3e024e.png";